import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { observer } from 'mobx-react'

import { EntityListCard } from 'Components/EntityListCard/EntityListCard'
import type { ParentChildRentalsEntityCardProps } from 'Components/ParentChildRentalsEntityCard/ParentChildRentalsEntityCard.types'
import {
  generateChildEntities,
  generateParentEntity,
} from 'Components/ParentChildRentalsEntityCard/ParentChildRentalsEntityCard.utils'

import { useIsOrganisation } from 'Hooks'

import type { getRental_rental_children } from 'Constants/graphql/queries/detail/__generated__/getRental'

export const ParentChildRentalsEntityCard = observer(
  (props: ParentChildRentalsEntityCardProps) => {
    const { rentalParent, rentalChildren } = props

    const isOrganisation = useIsOrganisation()
    const { employeeId, organisationId } = useParams<{
      employeeId?: string
      organisationId?: string
    }>()

    if (rentalParent) {
      const parentEntity = useMemo(
        () =>
          generateParentEntity({
            employeeId,
            isOrganisation,
            organisationId,
            parentRental: rentalParent,
          }),
        [employeeId, isOrganisation, organisationId, rentalParent],
      )

      return <EntityListCard entities={parentEntity} title="Main_rental" />
    }

    const filteredRentalChildren =
      rentalChildren?.filter(
        (childRental): childRental is getRental_rental_children =>
          childRental !== null,
      ) || []

    if (filteredRentalChildren.length > 0) {
      const childEntities = useMemo(
        () =>
          generateChildEntities({
            childRentals: rentalChildren,
            employeeId,
            isOrganisation,
            organisationId,
          }),
        [employeeId, isOrganisation, organisationId, rentalChildren],
      )

      return childEntities.length > 0 ? (
        <EntityListCard
          entities={childEntities}
          title={
            childEntities.length === 1
              ? 'Associated_rental'
              : 'Associated_rentals'
          }
        />
      ) : null
    }

    return null
  },
)
